import { Link, useParams } from "react-router-dom"
import React, { useEffect } from "react"
import NavMain from "../../app/NavMain"
import { Helmet } from "react-helmet-async"
import Layout from "../../ui/Layout"
import ScrollablePage from "../../ui/ScrollablePage"
import Paper from "../../ui/Paper"
import { fetchCollectionsById, selectCollectionsById } from "./slice"
import { useDispatch, useSelector } from "react-redux"
import {
  clearMatches,
  fetchObservationsByIds,
  selectObservationsById,
  selectObservationsByIds,
} from "../observations/slice"
import ObservationsTable from "../observations/ObservationsTable"
import PropTypes from "prop-types"
import Timestamp from "../../ui/Timestamp"
import { selectAdvancedMode } from "../settings/slice"
import ErrorMsg from "../../ui/ErrorMsg"
import AstrositeName from "../astrosites/AstrositeName"
import LoadingSpinner, { Backdrop } from "../../ui/LoadingSpinner"
import PaperTitle, { TitleText } from "../../ui/PaperTitle"
import { Facts, Header, Overview } from "../../ui/PageHeader"
import Breadcrumbs from "../../ui/Breadcrumbs"
import IDCopy from "../../ui/IDCopy"

const Collection = () => {
  const dispatch = useDispatch()
  // const [observations, setObservations] = useState([])
  const { id } = useParams()
  const collectionsById = useSelector(selectCollectionsById)
  const collection = collectionsById && collectionsById[id]
  // The observations linked to this collection
  const observationsById = useSelector(selectObservationsById)
  // User setting to show more details such as id's
  const advancedMode = useSelector(selectAdvancedMode)

  useEffect(() => {
    dispatch(clearMatches())
    dispatch(fetchCollectionsById(id)).then(() => {})
  }, [id])

  useEffect(() => {
    if (collection && collection._loadStatus != "loading") {
      dispatch(fetchObservationsByIds(collection.recordings))
    }
  }, [collection])

  const matchingObservationIds = (collection?.recordings || []).filter(
    (id) => observationsById[id]
  )
  // We get the full objects from the ids the match
  const matchingObservations = useSelector((state) =>
    selectObservationsByIds(state, matchingObservationIds || [])
  )

  return (
    <Layout>
      <NavMain />
      <Helmet>
        <title>Collection {id} - Astrosite</title>
      </Helmet>
      {!collection?.name && collection?._loadStatus === "loading" && (
        <Backdrop>
          <LoadingSpinner />
        </Backdrop>
      )}
      <ScrollablePage>
        <Header>
          <Overview>
            <h1>{collection?.name}</h1>
            <Breadcrumbs>
              <Link to="/collections">Collections</Link>
              <IDCopy id={id} showCopy />
            </Breadcrumbs>
          </Overview>
          <Facts>
            <dt>Created by</dt>
            <dd>
              <AstrositeName astrositeId={collection?.created_by} />
            </dd>
            <dt>Last updated</dt>
            <dd>
              {collection?.updated && (
                <Timestamp utc={advancedMode} columnMode={false}>
                  {collection.updated}
                </Timestamp>
              )}
            </dd>
          </Facts>
          {/*<Actions>*/}
          {/* TODO download collection link */}
          {/*<Action>*/}
          {/* */}
          {/*<Action>*/}
          {/*</Actions>*/}
        </Header>
        {collection?._loadStatus === "rejected" && (
          <ErrorMsg
            msg={`There is a problem fetching the collection with ID ${id}`}
            showIcon={true}
          />
        )}
        {collection?.recordings && (
          <CollectionObservations
            collectionId={id}
            collection={collection}
            observationIds={collection.recordings}
            observations={matchingObservations}
          />
        )}
      </ScrollablePage>
    </Layout>
  )
}

// Renders a table of the observations that the relevant rso is in (no filters)
const CollectionObservations = ({
  collectionId,
  collection = {},
  observationIds = [],
  observations = [],
}) => {
  const loadStatus =
    collection &&
    collection.recordings &&
    collection.recordings[0] &&
    observations &&
    observations[0]
      ? observations[0]._loadStatus
      : "idle"

  return (
    <Paper>
      <PaperTitle>
        <TitleText loadingState={loadStatus || "idle"}>
          Observations in collection ({observationIds?.length || 0})
        </TitleText>
      </PaperTitle>
      {loadStatus == "rejected" && (
        <ErrorMsg
          msg={"Problem loading the matching observations"}
          showIcon={true}
        />
      )}
      <ObservationsTable
        observations={observations.filter((o) => o.astrosite)}
        collectionId={collectionId}
        hideFilters={true}
      />
    </Paper>
  )
}

CollectionObservations.propTypes = {
  collectionId: PropTypes.string.isRequired,
  collection: PropTypes.object,
  observationIds: PropTypes.array,
  observations: PropTypes.array,
}

export default Collection
